import Validator from '@shared/validatorjs/src/validator';
import { UpdateField, SetDefaultData, CreateOrganizationRequest } from './../organizations.actions';
import { getCreateOrganizationState } from './../organizations.selectors';
import { Store, select } from '@ngrx/store';
import { Component, OnInit, OnDestroy } from '@angular/core';
import FormTrait from 'src/app/traits/form.trait';
import { Subscription } from 'rxjs';
import { Map } from 'immutable';

@Component({
  selector: 'app-create-organization',
  templateUrl: './create-organization.component.html',
  styleUrls: ['./create-organization.component.css']
})
export class CreateOrganizationComponent extends FormTrait implements OnInit, OnDestroy {

  private state$: Subscription;
  public isLoading: boolean;
  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('createOrganization'))
    this.state$ = this.store.pipe(select(getCreateOrganizationState)).subscribe(state => {
      this.state = state;
      this.isLoading = state.get('isLoading')
    });
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {

    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'createOrganization.data')
    );

    this.store.dispatch(
      new UpdateField('validationErrors', this.state
        .get('validationErrors')
        .delete(name || e.target.name), 'createOrganization')
    );
  }

  validation() {
    const data = this.state.get('data');
    const rules = {
      name: "required",
    };
    const validator = new Validator(
      {
        name: data.get('name'),
      },
      rules,
    );

    return validator;
  }

  public onSubmit(e: Event): void {
    e.preventDefault();
    const validation = this.validation();
    const payload = this.state.get('data').toJS();

    if (validation.passes()) {
      this.store.dispatch(new CreateOrganizationRequest(payload));
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, 'createOrganization')
      );
    }
  }

}
